import { CalendarClock } from 'lucide-react';

import { formatarProxima } from '@/lib/fuso';

/** Prévia vinda do servidor: as mesmas datas que o agendador vai seguir. */
export function ProximasConsultas({
  proximas,
  fuso,
  aviso,
}: {
  proximas: readonly string[];
  fuso: string;
  /** Por que não há prévia (desligada, alterações por salvar). */
  aviso: string | null;
}) {
  return (
    <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1 text-sm">
      <span className="inline-flex items-center gap-1.5 font-medium">
        <CalendarClock className="size-4 text-texto-suave" aria-hidden /> Próximas
      </span>
      {aviso || proximas.length === 0 ? (
        <span className="text-texto-fraco">{aviso ?? 'Nenhuma consulta agendada.'}</span>
      ) : (
        <ul aria-label="Próximas consultas" className="flex flex-wrap gap-x-3 gap-y-1">
          {proximas.map((p) => (
            <li key={p} className="tabular text-texto-suave first:font-semibold first:text-texto">
              <time dateTime={p}>{formatarProxima(p, fuso)}</time>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
